import { generatePDFFromText } from './shared';

export const generateExecutionChecklist = async (data, logoData) => {
  const content = `CONTRACT # ${data.contractNumber}
  
HEADER_SECTION_BLACK:Promotion Execution Checklist – Number Match

The following promotion execution procedures must be followed in order for an eligible prize claim:

1. Appoint a promotion administrator to oversee the execution of the promotion.
   a. It is the responsibility of the promotion administrator to post the promotion rules and to ensure the proper execution of the promotion.
   b. The promotion administrator will be required to sign a certified affidavit, submit a recorded witness statement, and may be required to submit to a polygraph test.

2. Post the predetermined winning number(s), the prize(s) and its associated prize value(s), as required by law.
   a. Winning number(s) may only be posted in the approved redemption location(s).
   b. Participants may not be contacted in any manner other than mailing them the direct mail game piece.
   c. The winning unique number may not be released over the phone, promoted in any form of advertisement including the internet, social media sites or revealed in any other manner other than display at an approved redemption location.

3. Prior to accepting a prize claim, confirm the following with participant:
   a. The participant must have a valid U.S. driver's license.
   b. The participant must be in possession of their original direct mail piece printed with their own name and/or address. Participant may not participate in the promotion on behalf of another individual or using another person's direct mail piece. 
   
   IMPORTANT: The winning mail piece must be redeemed by the participant named on the piece IN PERSON!

4. In order for a valid prize claim:
   a. An eligible participant must be in possession of their original direct mail piece printed with a winning number that is on file with Administrator.
   b. The participant must be addressee printed on the direct mail piece that is on file with Administrator.

HEADER_SECTION_BLACK:In the event of a Prize Winning Claim:

1. Obtain the original Direct Mail Piece from the participant to forward to SRMG.

2. Obtain the following information and materials from the participant:
      a. Complete the Winner's Affidavit Form with the participant's name, address and phone number(s)
   b. Copy of participants VALID U.S. driver's license and/or proof of residency documents per rules
   c. Provide a photocopy of your valid driver's license. The address on your valid driver's license must exactly match the address as printed on your mail piece. If the address on driver's license does not exactly match the address printed on the mail piece, you must submit proof of residency document(s) that exactly match the address on the mailer. You must supply the following as proof of residency: Copy of mortgage statement, lease/rental agreement, W2 Form, or property tax statement or two of the following most recent: utility bill, bank statement, current pay stub, credit card statement, or vehicle registration.

3. IMPORTANT: Complete the enclosed Winner's Affidavit Form at the time of the prize claim.
   a. Must be signed by the participant on date of prize claim.
   b. Must be signed by the promotion administrator on date of prize claim.

4. Complete the enclosed W-9 Form.

5. Contact SRMG within one (1) business day from the date of receipt of the winning prize claim.

6. Provide participant with a photocopy of their original mail piece.

7. Send copies of the direct mail piece, W-9 Form, participant's U.S. driver's license and/or proof of residency documents and signed Winner's Affidavit form to SRMG at (813) 295-2577 or scan and email to production@srmgauto.com within one (1) hour of receipt of the winning prize claim.

The materials must be forwarded via overnight mail within five (5) business days of date of receipt to: Strictly Results Marketing Group, Attn: Claims Department – Direct Mail, 410 Ware Blvd, Suite 1037, Tampa, FL 33619

Warning: Failure to follow these required contest procedures will result in a claim denial. Each participating redemption location and promotion administrator are responsible for compliance with the Official Rules, the Terms and Conditions of the contract and all applicable laws and regulations. SRMG is not liable for any prize payment or reimbursement or for any claims or damages (resulting, in whole or in part, from the Promotion not being conducted in accordance with the Official Rules, the Terms and Conditions of the contract, and any applicable laws and regulations).`;

  return generatePDFFromText({
    text: content,
    name: 'Execution_Checklist',
    logoData,
    headerTitle: `${data.dealershipName} Promotion`,
    baseFontSize: 8,   
    margin: 14,        
    justify: true,
    justifyLastLine: true
  });
};
